function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40px",
    height: "40px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#9147ff",
    d: "M 0.5,-0.5 C 13.1667,-0.5 25.8333,-0.5 38.5,-0.5C 38.5,0.166667 38.8333,0.5 39.5,0.5C 39.5,3.5 39.5,6.5 39.5,9.5C 35.3977,14.1046 31.0643,18.6046 26.5,23C 21.5429,24.8611 16.5429,24.8611 11.5,23C 7.99732,18.3312 3.99732,14.1645 -0.5,10.5C -0.5,7.16667 -0.5,3.83333 -0.5,0.5C 0.166667,0.5 0.5,0.166667 0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#9147ff",
    d: "M 17.5,39.5 C 15.8333,39.5 14.1667,39.5 12.5,39.5C 12.3345,35.4862 12.5012,31.4862 13,27.5C 16.7436,26.374 20.577,26.2073 24.5,27C 25.6023,29.4009 25.769,31.9009 25,34.5C 22.5205,36.3141 20.0205,37.9808 17.5,39.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.e6cc93eea43eab39467645e2c62a5acc.svg";
export { ForwardRef as ReactComponent };